export default "__VITE_ASSET__CvSseptr__"